import { checkRole, findServiceArea, getAddressDetails, nonZeroCoordinateValidator, spaceTypeList } from './../../../utils/utils.common';
import { Component, OnInit, Input, Output, EventEmitter, ElementRef, OnChanges, SimpleChanges, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { Observable, Subject, forkJoin } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
import { Router, ActivatedRoute } from '@angular/router';
import { getBrokersList, getstandingOrderDays } from '../../../utils/utils.common';
import * as moment from 'moment-timezone';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { KeyValue } from '@angular/common';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
// import { ProTipsServiceService } from '../../helping-material/nemt-pro-tips/service/pro-tips-service.service';
import { imageProcessing } from 'src/app/utils/image-processing-utils';
import { ToastrService } from 'ngx-toastr';
import { AssigTripsService } from 'src/app/service/assigntrips-service/assigntrips-service';
import { DriversService } from 'src/app/service/drivers-service/drivers-service';
import { MemberService } from 'src/app/service/member-service/member.service';
import { CorporateService } from 'src/app/service/corporate-service/corporate-service';
import { LevelOfServiceService } from 'src/app/service/level-of-service/level-of-service.service';
import { PrimaryDiagnosisService } from 'src/app/service/primary-diagnosis-service/primary-diagnosis.service';
import { ServiceAreasService } from 'src/app/service/service-areas-service/service-areas.service';
import { ModifierCodesService } from 'src/app/service/modifier-codes-service/modifier-codes.service';
import { TripPurposesService } from 'src/app/service/trip-purposes/trip-purposes.service';
import { EquipmentService } from 'src/app/service/equipment-service/equipment.service';
import { ProTipsService } from 'src/app/service/ProTips/pro-tips.service';
import { C } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-new-trip',
  templateUrl: './new-trip.component.html',
  styleUrls: ['./new-trip.component.css']
})
export class NewTripComponent implements OnInit, OnDestroy {
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @Input('editId') editId;
  @Output() onUpdate = new EventEmitter<string>();

  newTripForm: FormGroup;
  addonsServicesForm: FormGroup;
  timeZone = "America/New_York";
  todayDate = moment().tz(this.timeZone);
  user;
  memberList = [];
  fundingSourceList = [];
  tripPurposeList =[];
  modifierList =[];
  levelOfServiceList = [];
  spaceTypeList = [];
  spaceTypeMainList = [];
  serviceAreaList = [];
  primaryDiagnoseList = [];
  addonsList = [];
  filteredAddonsList = [];
  driverList = [];
  isAllowRates = false;
  tripId;
  submitted = false;
  addMemberModalObj = null;
  addressPickerObj;
  showTime = 'both';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private socketService: SocketService,
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private equipmentService: EquipmentService,
    private proTipsService : ProTipsService,
    private driverService: DriversService,
    private toastr: ToastrService,
    private tripPurposesService: TripPurposesService,
    private memberService: MemberService,
    private corporateService: CorporateService,
    private modifierCodesService: ModifierCodesService,
    private levelOfServiceService: LevelOfServiceService,
    private primaryDiagnosisService: PrimaryDiagnosisService,
    private serviceArea: ServiceAreasService
  ) {
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.url.length === 3 && this.activatedRoute.snapshot.url[2].path === 'edit') {
      this.tripId = this.activatedRoute.snapshot.url[1].path;
    }


    this.newTripForm = this.fb.group({
      company: ['', Validators.required],

      rawId: [''],
      tripId: [''],
      isMedical: [false], // will remove later
      companyType: [''], // will remove later
      jobType: ['cooperate', Validators.required], // will remove later

      jobDestinationAddress: ['', Validators.required],
      jobDestinationLatitude: [0, nonZeroCoordinateValidator()],
      jobDestinationLongitude: [0, nonZeroCoordinateValidator()],
      zipCodeDest: [''],

      jobOriginAddress: ['', Validators.required],
      jobOriginLatitude: [0, nonZeroCoordinateValidator()],
      jobOriginLongitude: [0, nonZeroCoordinateValidator()],
      zipCodeOrg: [''],

      client: ['', Validators.required],
      los: ['', Validators.required],
      losDetails: [{}, Validators.required],
      spaceType: ['', Validators.required],
      spaceTypeDetails: [{}, Validators.required],

      priorityClient: this.fb.group({
        displayName: ['', Validators.required],
        contactNumber: ['', Validators.required],
        cellPhone: [''],
        clientId: [''],
        email: [''],
        preDob: [''],
        dob: [''],
        weight: [''],
        gender: ['']
      }),

      originAddressAdditional: this.fb.group({
        modifier: [''],
        modifierTwo: [''],
        floor: [''],
        room: [''],
        aptOrSuite: [''],
        place: [''],
        phone: ['']
      }),
      destinationAddressAdditional: this.fb.group({
        modifier: [''],
        modifierTwo: [''],
        floor: [''],
        room: [''],
        aptOrSuite: [''],
        place: [''],
        phone: ['']
      }),

      cooperate: ['', Validators.required],
      cooperateDetails: [{}],

      preScheduleTime: ["", Validators.required],
      preAppointmentTime: ["", Validators.required],
      appointmentTime: ["", Validators.required],
      scheduleTime: ["", Validators.required],
      viewStatus: ["created", Validators.required],

      milage: [null],
      tripLegs: this.fb.array([]),
      addonServices: this.fb.array([]),
      noOfEscorts: [''],
      tripReason: [[]],
      ipa: [''],
      primaryDiagnosis: [''],
      companyNote: [''],
      dispatchNoteTwo: [''],
      attachment: [''],

      preRecurringEndDate: [null],
      recurringEndDate: [''],
      isStandingOrder: [false],
      isRecurring: [false],
      recurringDays: this.fb.array([]),
      status: [''],
      jobStatus: [''],
      driver: [null],
      events: [[]],
      serviceArea: ['', Validators.required],
      serviceAreaDest: ['', Validators.required],
      // Local Variable
      estimateFare: [{ value: '', disabled: true }],
      isVipTrip: [false],
      isConfirmedTrip: [false],
      isMethadone: [false],
      authorizationNumber: [''],
      isWillCall: [false],
    });
    this.addStandingDays();


    if (this.editId) {
      this.tripId = this.editId;
    }
    this.getUser();
    this.makeCompulsoryCalls();
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getConfigurations()
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1]) => {

        if (res1) {
          this.levelOfServiceList = res1.levelofservices;
          this.spaceTypeMainList = res1.spacetypes;
          this.serviceAreaList = res1.serviceareas
        }
        this.getMemberList();
        this.getTripPurposeList();
        this.getFundingSourceList();
        this.getModifierList();
        this.getPrimaryDiagnoseList();
        // this.getAddonsList();
        // this.getServiceAreaList();
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.company.timeZone;
          this.todayDate = moment().tz(this.timeZone);
          this.setCorporateUser(user)

          this.newTripForm.patchValue({
            company: this.user.company._id,
            cooperate: this.user.cooperate ? this.user.cooperate._id : this.user._id,
            preScheduleTime: this.todayDate,
            scheduleTime: this.todayDate.toISOString(),
            preAppointmentTime: moment(this.todayDate).add(1, 'hours'),
            appointmentTime: moment(this.todayDate).add(1, 'hours').toISOString(),
          });

          const showTime = this.user.cooperate ? this.user.cooperate.showTime : this.user.showTime;
          if (showTime) {
            this.showTime = showTime;
          }
          
          this.getDriverList();

          if (this.tripId) {
            this.getTripDetails();
          }

          this.isAllowRates = checkRole(this.user);
        }
      });
  }

  getTripDetails() {
    this.assignTripService
      .getUnassignedTripDetailById(this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          const preData = JSON.parse(JSON.stringify(data));
          // remove standing order
          delete preData.recurringDays;
          delete preData.addonServices;

          this.newTripForm.patchValue({
            ...preData,
            viewStatus:'updated',
            preScheduleTime: moment(preData.scheduleTime).tz(this.timeZone),
            preAppointmentTime: moment(preData.appointmentTime).tz(this.timeZone),
            preRecurringEndDate: preData.recurringEndDate ? moment(preData.recurringEndDate).tz(this.timeZone) : null,
            priorityClient: {
              ...preData.priorityClient,
              preDob: (preData.priorityClient && preData.priorityClient.dob) ? moment(preData.priorityClient.dob).tz(this.timeZone) : '',
              dob: preData.priorityClient.dob,
            }
          });


          if (preData.spaceType) {
            const filteredSpaceTypes = this.spaceTypeMainList.filter(item => item.los === preData.spaceType.los);
            this.spaceTypeList = filteredSpaceTypes;
          }

          if (data.cooperate) {
            this.getAddonsList(data.cooperate);
          }

          if (data.addonServices) {
            this.addAddonsItem(data.addonServices);
          }

          if (data.status === "standing") {
            this.addStandingDays(data.recurringDays);
          }

        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }


  getMemberList() {
    const queryParam = {
      accountStatus: 'active',
    }
    
    this.memberService
      .getMembers(queryParam)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.memberList = data;
        }
      });
  }

  getTripPurposeList() {
    this.tripPurposesService
      .getTripPurposesList('active')
      .subscribe(data => {
        if (data) {
          this.tripPurposeList = data;
        }
      });
  }

  getFundingSourceList() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.fundingSourceList = data;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getModifierList() {
    this.modifierCodesService
      .getModifierCodes()
      .subscribe(data => {
        if (data) {
          this.modifierList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getConfigurations() {
    return this.assignTripService.getConfigurations({ status: 'active' });
  }

  getPrimaryDiagnoseList() {
    this.primaryDiagnosisService
      .getPrimaryDiagnosis()
      .subscribe(data => {
        if (data) {
          this.primaryDiagnoseList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getAddonsList(fundingSourceId) {
    //add params to send the cooperate key in the equipment api
    let queryParams = {
      isAddon: true,
      cooperate: fundingSourceId
    }
    this.equipmentService
      .getEquipments(queryParams)
      .subscribe(data => {
        if (data) {
          this.addonsList = data;
          this.filteredAddonsList = data;
          this.onSelectSpaceType();

        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user.company._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
        }
      });
  }

  get form() {
    return this.newTripForm.controls;
  }

  get legForm() {
    return this.newTripForm.get('tripLegs') as FormArray;
  }
  addLegItem() {
    const items = this.newTripForm.get('tripLegs') as FormArray;
    let preValues;
    if (items.length === 0) {
      preValues = this.newTripForm.value
    } else {
      preValues = items.at(items.length - 1).value;
    }

    let hour = items.length === 0 ? 1 : 2;
    // if (!items.invalid) {
    items.push(
      this.fb.group({
        jobDestinationAddress: [preValues.jobOriginAddress, Validators.required],
        jobDestinationLatitude: [preValues.jobOriginLatitude, nonZeroCoordinateValidator()],
        jobDestinationLongitude: [preValues.jobOriginLongitude, nonZeroCoordinateValidator()],
        zipCodeDest: [preValues.zipCodeOrg],
        serviceAreaDest: [preValues.serviceArea],

        jobOriginAddress: [preValues.jobDestinationAddress, Validators.required],
        jobOriginLatitude: [preValues.jobDestinationLatitude, nonZeroCoordinateValidator()],
        jobOriginLongitude: [preValues.jobDestinationLongitude, nonZeroCoordinateValidator()],
        zipCodeOrg: [preValues.zipCodeDest],
        serviceArea: [preValues.serviceAreaDest],

        preScheduleTime: [moment(preValues.preAppointmentTime).add(hour, 'hours'), Validators.required],
        scheduleTime: [moment(preValues.preAppointmentTime).add(hour, 'hours').toISOString(), Validators.required],
        preAppointmentTime: [moment(preValues.preAppointmentTime).add(hour, 'hours'), Validators.required],
        appointmentTime: [moment(preValues.preAppointmentTime).add(hour, 'hours').toISOString(), Validators.required],
        companyNote: [''],
        isWillCall: [false],

        originAddressAdditional: this.fb.group({
          modifier: [preValues.destinationAddressAdditional.modifier],
          modifierTwo: [preValues.destinationAddressAdditional.modifierTwo],
          floor: [preValues.destinationAddressAdditional.floor],
          room: [preValues.destinationAddressAdditional.room],
          aptOrSuite: [preValues.destinationAddressAdditional.aptOrSuite],
          place: [preValues.destinationAddressAdditional.place],
          phone: [preValues.destinationAddressAdditional.phone]
        }),
        destinationAddressAdditional: this.fb.group({
          modifier: [preValues.originAddressAdditional.modifier],
          modifierTwo: [preValues.originAddressAdditional.modifierTwo],
          floor: [preValues.originAddressAdditional.floor],
          room: [preValues.originAddressAdditional.room],
          aptOrSuite: [preValues.originAddressAdditional.aptOrSuite],
          place: [preValues.originAddressAdditional.place],
          phone: [preValues.originAddressAdditional.phone]
        }),


      })
    );
    // }
  }

  removeLegItem(index: any) {
    const items = this.newTripForm.get('tripLegs') as FormArray;
    items.removeAt(index);
  }

  get addonsForm() {
    return this.newTripForm.get('addonServices') as FormArray;
  }

  addAddonsItem(preAddonList?) {
    const items = this.newTripForm.get('addonServices') as FormArray;

    if (preAddonList) {
      for (const addon of preAddonList) {
        items.push(
          this.fb.group({
            addonId: [addon.addonId, Validators.required],
            quantity: [addon.quantity, [Validators.required, Validators.min(1)]],
            title: [addon.title],
            fare: [addon.fare],
            code: [addon.code],
            total: [addon.total]
          })
        );

      }
      return;
    }

    // if (!items.invalid) {
    items.push(
      this.fb.group({
        addonId: ['', Validators.required],
        quantity: [1, [Validators.required, Validators.min(1)]],
        title: [''],
        fare: [0],
        code: [0],
        total: [0]
      })
    );
    // }
  }

  removeAddonsItem(index: any) {
    const items = this.newTripForm.get('addonServices') as FormArray;
    items.removeAt(index);
  }


  onSelectMember(event) {
    let member;
    if (event) {
      member = this.memberList.find((member) => member._id === event);

    }
    this.setMemberDetails(member);
  }

  setMemberDetails(member) {
    try {
      if (member) {
        let memberPayload;
        memberPayload = {
          priorityClient: member,
          isVipTrip: member.type === "vip" ? true : false,
          originAddressAdditional: {
            phone: member.contactNumber,
            dispatchNoteTwo: member.note + " ----------  " + member.privateNote,
          }
        }

        if (member.homeAddress && member.homeAddress.address) {
          memberPayload = {
            ...memberPayload, jobOriginAddress: member.homeAddress.address,
            jobOriginLatitude: member.homeAddress.latitude,
            jobOriginLongitude: member.homeAddress.longitude,
            zipCodeOrg: member.homeAddress.zipCode
          };
        }

        if (member.homeAddress && member.homeAddress.name) {
          memberPayload = {
            ...memberPayload,
            originAddressAdditional: {
              ...memberPayload.originAddressAdditional,
              place: member.homeAddress.name,
            }
          };
        }

        if (member.fundingSource) {
          memberPayload = { ...memberPayload, cooperate: member.fundingSource };
        }

        if (member.spaceType) {
          memberPayload = { ...memberPayload, spaceType: member.spaceType, los: member.los };
        }
        if (member.dob) {
          memberPayload = {
            ...memberPayload,
            priorityClient:{
              ...memberPayload.priorityClient,
              preDob:moment(member.dob),
              dob: member.dob
            }

          };

        }

        this.newTripForm.patchValue(memberPayload);

        if (member.spaceType) {
          const filteredSpaceTypes = this.spaceTypeMainList.filter(item => item.los === member.spaceType.los);
          this.spaceTypeList = filteredSpaceTypes;
        }

      } else {
        this.newTripForm.patchValue({
          priorityClient: {
            displayName: '',
            contactNumber: '',
            cellPhone: '',
            clientId: '',
            email: '',
            dob: '',
            weight: '',
            gender: ''
          },
        });
      }
    } catch (err) {
      (err);
    }
  }

  setOriginAddress(place, index?) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    const myServiceArea = findServiceArea(zip, this.serviceAreaList);

    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        jobOriginAddress: place.formatted_address,
        jobOriginLatitude: place.geometry.location.lat(),
        jobOriginLongitude: place.geometry.location.lng(),
        zipCodeOrg: zip,
        serviceArea: myServiceArea
      });
    } else {
      this.newTripForm.patchValue({
        jobOriginAddress: place.formatted_address,
        jobOriginLatitude: place.geometry.location.lat(),
        jobOriginLongitude: place.geometry.location.lng(),
        zipCodeOrg: zip,
        serviceArea: myServiceArea
      });
    }
  }

  setDestinationAddress(place, index?) {
    const addressDetails = place ? getAddressDetails(place) : undefined;
    const zip = addressDetails.zipCode;
    const myServiceArea = findServiceArea(zip, this.serviceAreaList);
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        jobDestinationAddress: place.formatted_address,
        jobDestinationLatitude: place.geometry.location.lat(),
        jobDestinationLongitude: place.geometry.location.lng(),
        zipCodeDest: zip,
        serviceAreaDest: myServiceArea
      });
    } else {
      this.newTripForm.patchValue({
        jobDestinationAddress: place.formatted_address,
        jobDestinationLatitude: place.geometry.location.lat(),
        jobDestinationLongitude: place.geometry.location.lng(),
        zipCodeDest: zip,
        serviceAreaDest: myServiceArea
      });
    }
  }

  setPickTimeChange(event, index?) {
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        scheduleTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

      if (!this.tripId) {
        items.at(index).patchValue({
          preAppointmentTime: moment(event).add(1, 'hours')
        });
      }

    } else {
      this.newTripForm.patchValue({
        scheduleTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

      if (!this.tripId) {
        if (this.showTime === 'scheduleOnly' || this.showTime === 'both'){
          this.newTripForm.patchValue({
            preAppointmentTime: moment(event).add(1, 'hours')
          });
        }else{
          this.newTripForm.patchValue({
            preAppointmentTime: moment(event)
          });
        }
      }
    }
  }

  setDropOffTimeChange(event, index?) {
    if (index > -1) {
      const items = this.newTripForm.get('tripLegs') as FormArray;
      items.at(index).patchValue({
        appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
      });

    } else {
      this.newTripForm.patchValue({
        appointmentTime: moment(event).tz(this.timeZone, true).toISOString(),
      });
      if (this.showTime === 'appointmentOnly'){
        this.newTripForm.patchValue({
          preSchduleTime: moment(event).subtract(1, 'hours')
        });
      }
    }
  }

  setWillCall(event, index) {
    const items = this.newTripForm.get('tripLegs') as FormArray;

    if (event.target.checked) {
      const time = items.at(index)['controls'].preScheduleTime.value;
      time.set('hour', 23)
      time.set('minute', 59)
      items.at(index)['controls'].preScheduleTime.setValue(time);
      items.at(index)['controls'].preAppointmentTime.setValue(time);
      items.at(index)['controls'].appointmentTime.setValue(time.toISOString());
      

      items.at(index)['controls'].preScheduleTime.disable();
    } else {
      items.at(index)['controls'].preScheduleTime.enable();
    }

  }

  setCorporateUser(corporate) {
    this.newTripForm.patchValue({
      cooperateDetails: {
        displayName: '',
        profileImageURL: ''
      },
      cooperate:''
    });

    // const fundingSource = this.fundingSourceList.find((fundingSource) => fundingSource._id === event);
    if (corporate) {
      this.newTripForm.patchValue({
        cooperateDetails: {
          displayName: corporate.displayName,
          profileImageURL: corporate.profileImageURL
        },
        cooperate:corporate._id
      });
      //Additional Code removed, clearing the array on change of funding source
      this.getAddonsList(corporate._id);

    }
    const addonServices = this.newTripForm.get('addonServices') as FormArray;
    // addonServices.clear();
  }

  onSelectSpaceType() {
    const selectedSpaceType = this.spaceTypeMainList.find(
      spaceTypeItem => spaceTypeItem._id === this.newTripForm.value.spaceType
    );

    if (selectedSpaceType) {
      this.newTripForm.patchValue({
        los: selectedSpaceType.los,  // Patch the LOS value from the selected spaceType
      });
    } else {
      this.newTripForm.patchValue({
        los: '',  // Clear the LOS if no valid spaceType is selected
      });
    }

    const addonServices = this.newTripForm.get('addonServices') as FormArray;
    this.filteredAddonsList = this.addonsList.filter(
      item => item.spaceType === this.newTripForm.value.spaceType
    );
  }



  onSelectAddonItem(addonItem) {
    if (!addonItem.value.addonId || !addonItem.value.quantity) return;

    const item = this.addonsList.find(item => item._id === addonItem.value.addonId);
    addonItem.patchValue({
      ...item,
      total: item.fare * addonItem.value.quantity
    });
  }

  //  Missing  

  async fileProcessing(ImageInput, form) {
    imageProcessing(ImageInput)
      .subscribe(async (result) => {
        const data: any = await this.proTipsService.changeCoverImage(result.file).toPromise();
        form.setValue(data.location);
      })
  }

  removeFile() {
    this.newTripForm.patchValue({ attachment: '' });
    this.fileInput.nativeElement.value = '';
  }


  get standingOrderForm() {
    return this.newTripForm.get('recurringDays') as FormArray;
  }

  addStandingDays(preStandingList?) {

    const recurringDaysItems = this.newTripForm.get('recurringDays') as FormArray;
    if (preStandingList) {

      for (let preItem of preStandingList) {
        const index = recurringDaysItems.controls.findIndex(item => item.value.day === preItem.day);
        if (index > -1) {
          recurringDaysItems.at(index).patchValue({
            checked: true,
            driver: preItem.driver ? preItem.driver : 'null'
          });

          recurringDaysItems.at(index)['controls'].driver.enable();
        }
      }
      return;
    }

    for (let dayItem of getstandingOrderDays) {
      recurringDaysItems.push(
        this.fb.group({
          label: [dayItem.label],
          day: [dayItem.day],
          checked: [false],
          driver: [{ value: 'null', disabled: true }],
        })
      );
    }
  }

  onChangeStandingDay(event, form) {
    if (event) {
      form.controls.driver.enable();
    } else {
      form.controls.driver.disable();
    }
  }

  onChangeStandingStatus(event) {
    const isEnabled = JSON.parse(event.target.value);
    if (this.tripId && !isEnabled) {
      sweetAlert('Alert', 'Are you sure you want to inactive standing orders? This action will reset the recurring date to today and remove all the future existing trips.', 'warning', 'Yes', 'No')
        .then((result: any) => {
          if (result.value) {
            const standingOrderDate = moment().tz(this.timeZone, true).startOf('day');
            if (this.newTripForm.value.recurringEndDate) {
              const previousDate = moment(this.newTripForm.value.recurringEndDate).tz(this.timeZone, true).startOf('day');
              if (previousDate.isAfter(standingOrderDate)) {
                this.newTripForm.patchValue({
                  preRecurringEndDate: standingOrderDate,
                  recurringEndDate: standingOrderDate.toISOString(),
                  isRecurring: isEnabled
                });
              } else {
                this.newTripForm.patchValue({
                  isRecurring: isEnabled
                });
              }
            } else {
              this.newTripForm.patchValue({
                preRecurringEndDate: standingOrderDate,
                recurringEndDate: standingOrderDate.toISOString(),
                isRecurring: isEnabled
              });
            }
          } else {
            this.newTripForm.patchValue({
              isRecurring: true
            });
          }
        });
    } else {
      this.newTripForm.patchValue({
        isRecurring: isEnabled
      });
    }
  }

  setStandingDateChange(event) {
    if (event) {
      this.newTripForm.patchValue({
        recurringEndDate: moment(event).tz(this.timeZone, true).startOf('day').toISOString()
      });
    }
  }

  onCreateTrip() {
    this.submitted = true;
    if (this.newTripForm.invalid) return;
    let payload = this.newTripForm.value;

    // checking standing orders
    if (payload.isRecurring) {
      let recurringDays = [];
      for (let standingOrderDay of payload.recurringDays) {
        if (standingOrderDay.checked) {
          recurringDays.push({ ...standingOrderDay, driver: standingOrderDay.driver === 'null' ? null : standingOrderDay.driver })
        }
      }

      if (recurringDays.length) {
        payload.recurringDays = recurringDays;
        payload.status = 'standing';
        payload.jobStatus = 'standing';
      }
      if (!payload.milage)
        delete payload.milage
    } else {
      delete payload.recurringDays
      delete payload.status
      delete payload.jobStatus
    }

    if (!payload.originAddressAdditional.modifier) {
      payload.originAddressAdditional.modifier = null
    }

    if (!payload.destinationAddressAdditional.modifier) {
      payload.destinationAddressAdditional.modifier = null
    }

    for (let leg of payload.tripLegs) {
      if (!leg.originAddressAdditional.modifier) {
        leg.originAddressAdditional.modifier = null
      }

      if (!leg.serviceArea) {
        leg.serviceArea = null
      }

      if (!leg.serviceAreaDest) {
        leg.serviceAreaDest = null
      }

      if (!leg.destinationAddressAdditional.modifier) {
        leg.destinationAddressAdditional.modifier = null
      }
    }


    this.assignTripService
      .createNewTripV2(payload, this.tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (this.editId) {
            this.onUpdate.emit(data);
          } else {
            this.router.navigateByUrl('trips');
          }
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });

  }

  openAddMemberModal(member) {
    this.addMemberModalObj = member;
  }

  onSaveMember(evt) {
    if (evt && this.memberList && this.memberList.length) {
      // Update existing member in the list
      const index = this.memberList.findIndex(member => member._id === evt._id);
      if (index !== -1) {
        this.memberList[index] = evt; // Update existing member
        this.memberList = [...this.memberList];
      } else {
        this.memberList.push(evt); // Add new member if not exists (fallback)
      }
  
      // Update the form with new member details
      this.newTripForm.patchValue({
        client: evt._id
      });
      this.setMemberDetails(evt);
      
      this.addMemberModalObj = null;
  
      // Refresh the dropdown by triggering change detection
    }
  }

  

  

  getServiceAreaList() {
    this.serviceArea
      .getServiceAreas({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.serviceAreaList = data;
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  calculateEstimatedFare() {
    const { jobOriginLatitude, jobOriginLongitude, jobDestinationLatitude, jobDestinationLongitude, scheduleTime, cooperate, spaceType, milage, addonServices } = this.newTripForm.value;

    if (!jobOriginLatitude || !jobOriginLongitude || !jobDestinationLatitude || !jobDestinationLongitude || !scheduleTime || !cooperate || !spaceType) {
      sweetAlert('Alert', 'Please select Pickup, Drop Off address, Space Type, Pickup Time & Funding Source', 'warning', 'Ok')
      return;
    }

    let payload;

    payload = {
      company: this.user.company._id,
      jobDestinationLatitude: jobDestinationLatitude,
      jobDestinationLongitude: jobDestinationLongitude,
      jobOriginLatitude: jobOriginLatitude,
      jobOriginLongitude: jobOriginLongitude,
      spaceType: spaceType,
      cooperate: cooperate,
      scheduleTime: scheduleTime
    };

    if (milage) {
      payload.milage = milage;
    }

    if (addonServices && addonServices.length) {
      payload = { ...payload, addonServices: addonServices }
    }

    this.assignTripService
      .calculateEstimateFare(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.newTripForm.patchValue({
            estimateFare: data.totalFare
          })
        }
      });
  }

  loadAddressPicker(title, value, address?, lat?, lng?, zipCode?) {
    this.addressPickerObj = { title, value, address, lat, lng, zipCode };
  }

  onAddressPicker(event) {
    debugger;
    this.addressPickerObj = null;
    const items = this.newTripForm.get('tripLegs') as FormArray;
    if (!event) return;

    // For Pickup Addresss
    if (event.reference.value === '0') {
      this.newTripForm.patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode
      });
    } else if (event.reference.value === '1') {
      this.newTripForm.patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode
      });
    } else if (event.reference.value === '01') {
      items.at(0).patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode
      });
    } else if (event.reference.value === '11') {
      items.at(0).patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode
      });
    } else if (event.reference.value === '02') {
      items.at(1).patchValue({
        jobOriginAddress: event.address,
        jobOriginLatitude: event.lat,
        jobOriginLongitude: event.lng,
        zipCodeOrg: event.zipCode
      });
    } else if (event.reference.value === '12') {
      items.at(1).patchValue({
        jobDestinationAddress: event.address,
        jobDestinationLatitude: event.lat,
        jobDestinationLongitude: event.lng,
        zipCodeDest: event.zipCode
      });
    }

    if (this.newTripForm.value.jobOriginAddress &&
      this.newTripForm.value.jobOriginLatitude &&
      this.newTripForm.value.jobOriginLongitude &&
      this.newTripForm.value.jobDestinationAddress &&
      this.newTripForm.value.jobDestinationLatitude &&
      this.newTripForm.value.jobDestinationLongitude) {
    }
  }

  onDateChange(evt, control: AbstractControl) {
    if (evt) {
      control.setValue(moment(evt).toISOString());
    }
  }

  ngOnDestroy(): void {
  }

    setWillCallInEdit(event) {
    if (event.target.checked) {
      const schTime = this.newTripForm['controls'].preScheduleTime.value;
      schTime.set('hour', 23)
      schTime.set('minute', 59)
      this.newTripForm['controls'].preScheduleTime.setValue(schTime);
      this.newTripForm['controls'].preScheduleTime.disable();

      // const aptTime = this.newTripForm['controls'].preAppointmentTime.value;
      // aptTime.set('hour', 23)
      // aptTime.set('minute', 59)
      this.newTripForm['controls'].preAppointmentTime.setValue(schTime);
      this.newTripForm['controls'].preAppointmentTime.disable();
    } else {
      this.newTripForm['controls'].preScheduleTime.enable();
      this.newTripForm['controls'].preAppointmentTime.enable();
    }
  }
}
